import { render, staticRenderFns } from "./MachineryProfile.vue?vue&type=template&id=b8c0ca3a&scoped=true"
import script from "./MachineryProfile.vue?vue&type=script&lang=ts"
export * from "./MachineryProfile.vue?vue&type=script&lang=ts"
import style0 from "./MachineryProfile.vue?vue&type=style&index=0&id=b8c0ca3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c0ca3a",
  null
  
)

export default component.exports